<template>
  <div class="learningReport2" id="learningReport">
    <div style="background: #fff; min-height: 600px">
      <div
        class="evaluationPeport_main"
        v-if="reportId && part1Data.test_id !== ''"
      >
        <div class="title">{{ user.realname }}学习力测评报告</div>
        <!-- 综合鑫都指数 -->
        <div>
          <div class="partTitle">综合信度指数</div>
          <div class="line"></div>
          <table>
            <tr>
              <th>综合信度指数</th>
              <td colspan="2">
                {{
                  reliability_index.comprehensiveReliabilityIndex
                }}（参考值：70↑）
              </td>
            </tr>
            <tr>
              <th>作答起止时间</th>
              <td colspan="2">
                {{ reliability_index.answerStartTime }} &nbsp;—&nbsp;
                {{ reliability_index.answerEndTime }}
              </td>
            </tr>
            <tr>
              <th rowspan="3">作答时间</th>
              <td>限时能力类测试</td>
              <td>
                {{ reliability_index.limitedTime }}分钟
                （参考时间：12.7-36.1分钟）
              </td>
            </tr>
            <tr>
              <td>非限时能力类测试</td>
              <td>
                {{ reliability_index.unlimitedTime }}分钟
                （参考时间：4.3-36分钟）
              </td>
            </tr>
            <tr>
              <td>量表类测试</td>
              <td>
                {{ reliability_index.questionnaireTime }}分钟
                （参考时间：5.9-15.6分钟）
              </td>
            </tr>
            <tr>
              <th>作答一致性</th>
              <td colspan="2">
                {{ reliability_index.consistency }}（参考值：0.7↑）
              </td>
            </tr>
            <tr>
              <th>作答规律性</th>
              <td colspan="2">{{ reliability_index.regularity }}次</td>
            </tr>
            <tr>
              <th>作答趋中性</th>
              <td colspan="2">{{ reliability_index.neutrality }}</td>
            </tr>
            <tr>
              <th>社会称许性</th>
              <td colspan="2">
                {{ reliability_index.cehuang }}（参考值：0.7↓）
              </td>
            </tr>
          </table>
        </div>
        <div class="buchongs">
          <!-- <a>报告解读：</a> -->
          <div class="textare">
            <el-input
                placeholder="咨询师解读"
                :disabled="true"
                type="textarea"
                maxlength="200"               
                show-word-limit
                v-model="reliabilityIndex">
            </el-input>
          </div>
        </div>
        <div>
          <PagePart5
                 v-if="isHadReport"
                :part2Total="part2Total"
                :normDataDongli="normDataDongli"
                :part3Total="part3Total"
                :part1Data="part1Data"
                :part1Norm="part1Norm"
                :part3Data="part3Data||[]"
                :part3StrategyNorm="part3StrategyNorm||[]"
                :styleNorm="part3style.norm||[]"
                :part4Data="part4Data"
                :part2Data="part2Data"
                :part2norm="part2Data.xuexidongli"
                :normDataMind="normDataMind"
                :core="core"
                :part2comment="part2Data.xuexidongli"  
                :part2="part2Data"
                :partIndex="part5Index"
                :isFinishPart123="isFinishPart123"
                :isFinishAll="isFinishAll"
                :total="total"
                :normData="normData.default"
                :part1Total="part1Total"    
                :headerLogo="headerLogo"

                :reliabilityIndex="reliabilityIndex"
                :learningAbility="learningAbility"
                :learningPotential="learningPotential"
                :learningStrategy="learningStrategy"
                :learningStyle="learningStyle"
                :learningMotivation="learningMotivation"    
                :mind="mind"

          >
          </PagePart5> 
      </div>

      </div>
      <div v-else class="noContent">
        <NoContent></NoContent>
      </div>     
    </div>
  </div>
</template>
<script>
import PagePart5 from './components3/PagePart5_edit.vue';//解读
import NoContent from "@/components/NoContent.vue";


export default {
  components: {PagePart5,NoContent },
  props: [],
  data() {
    return {
      reportId: "",
      catch_null: false,
      catch_data: "",
      isXljkReport: sessionStorage.getItem("isXljkReport"),
      isLoading: true,
      isDownloading: false, //是否正在下载
      totalPages: 1, //总页数
      currentPage: 0, //当前页
      // isDownlondPdf: true

      status: "", //B端直接查看报告时,用status代替接口返回回来的user.grade
      // 获取报告时用的参数
      userName: "",
      schoolID: "",
      startTime: "",
      endTime: "",

      htmlTitle: "",
      reportData: null,
      isHadReport: false,
      user: {},
      core: {},
      reliability_index: {},
      normData: {},
      part1Data: {},
      part2Data: {},
      part3Data: {},
      part3Strategy: {},
      part3style: {},
      part4Data: {},
      total: {},
      part5Index: 1,
      part1Index: 0,
      part2Index: 0,
      part3Index: 0,
      part4Index: 0,
      listData: [],
      list: [
        {
          title: "核心结果",
          num: "",
          sTitle: [
            { s_title: "核心结果总览", num: "", gTitle: [] },
            { s_title: "核心结果分析", num: "", gTitle: [] },
          ],
        },
        {
          title: "学习潜力",
          num: "",
          sTitle: [
            {
              s_title: "学习潜力",
              num: "",
              gTitle: [
                { g_title: "学习潜力评估结果", num: "" },
                { g_title: "学习潜力分析", num: "" },
              ],
            },
          ],
        },
        {
          title: "学习效力",
          num: "",
          sTitle: [
            {
              s_title: "学习策略",
              num: "",
              gTitle: [
                { g_title: "学习策略评估结果", num: "" },
                { g_title: "学习策略分析", num: "" },
              ],
            },
            {
              s_title: "学习风格",
              num: "",
              gTitle: [
                { g_title: "学习风格评估结果", num: "" },
                { g_title: "学习风格分析", num: "" },
              ],
            },
          ],
        },
        {
          title: "学习动力",
          num: "",
          sTitle: [
            {
              s_title: "学习态度",
              num: "",
              gTitle: [
                { g_title: "学习态度评估结果", num: "" },
                { g_title: "学习态度分析", num: "" },
              ],
            },
            {
              s_title: "学习动机",
              num: "",
              gTitle: [
                { g_title: "学习动机评估结果", num: "" },
                { g_title: "学习动机分析", num: "" },
              ],
            },
            {
              s_title: "学习效能感",
              num: "",
              gTitle: [
                { g_title: "学习效能感评估结果", num: "" },
                { g_title: "学习效能感分析", num: "" },
              ],
            },
          ],
        },
        {
          title: "心理风险",
          num: "",
          sTitle: [
            {
              s_title: "心理风险",
              num: "",
              gTitle: [
                { g_title: "心理风险评估结果", num: "" },
                { g_title: "心理风险分析", num: "" },
              ],
            },
          ],
        },
      ],
      hideDownload: true,
      headerLogo: "",
      reliabilityIndex:'',
      learningAbility:'',
      learningPotential:'',
      learningStrategy:'',
      learningStyle:'',
      learningMotivation:'',
      mind:''
    };
  },
  computed: {
    isFinishAll() {
            if(this.part1Data.test_id
                &&this.part3Data.test_id
                &&this.part2Data.test_id
                &&this.part4Data.test_id
            ) {
                return true
            }else {
                return false
            }
        },
        isFinishPart123() {
            if(this.part1Data.test_id
                &&this.part3Data.test_id
                &&this.part2Data.test_id
            ) {
                return true
            }else {
                return false
            }
        },
        normDataDongli() {
            let user = this.user;
            if(!user.grade) {
                return
            }
            if(user.grade=='高三') {
                // return this.normData.power.three;
                return this.normData.default;
            }else if(user.grade=='高二') {
                // return this.normData.power.two;
                return this.normData.default;
            }else if(user.grade=='高一') {
                // return this.normData.power.one;
                return this.normData.default;
            }else if(user.grade=='成年人'){
                // return this.normData.power.three;
                return this.normData.default;
            }else {
                // return this.normData.power.one;
                return this.normData.default;
            }
        },
        normDataMind() {
            return this.normData.mind;
        },    
        part1Total() {
            if(this.part1Data.test_id) {
                return this.part1Data.norm[10];
            }else {
                return null;
            }
        },  
        part2Total() {
            if(this.part2Data.test_id) {
                // console.log(11)
                return this.part2Data.xuexidongli;
            }else {
                // console.log(22)
                
                return null;
            }
        },
        part3Total() {
            if(this.part3Data.test_id) {
                return this.part3Strategy.norm[12];
            }else {
                return null;
            }
        },
        part1Norm() {
            if(this.part1Data.test_id) {
                return this.part1Data.norm.slice(0,10);
            }else {
                return [];
            }
        },
        part3StrategyNorm() {
            if(this.part3Data.test_id) {
                return this.part3Strategy.norm.slice(0,11);
            }else {
                return [];
            }
        },
  },
  watch: {},
  created() {
    // this.getReportData();
  },
  mounted() {
    this.getReportData();
  },
  methods: {
    // 获取学习力报告
    getReportData() {
      this.$ajax
        .post(
          this.G_lcapi + "/v2/report/c/getDataByUserInfo",
          {
            userName: window.sessionStorage.getItem("learningCapacityUser"),
            schoolID: window.sessionStorage.getItem("learningCapacitySchool"),
          },
          {
            headers: {
              token: window.sessionStorage.getItem("ymtxToken"),
            },
          }
        )
        .then((res) => {
          console.log(res);
          let data = res.data.result.data;
          if (res.data.result.user.length == 0) {
            this.reportId = false;
          } else {
            this.reportId = true;

            this.reportData = data;
            this.user = res.data.result.user;
            this.core = res.data.result.core;
            this.normData = res.data.result.norm;
            this.reliability_index = res.data.result.reliability;
            this.part1Data = data[1];
            this.part2Data = data[2];
            this.part3Data = data[3];
            this.part3Strategy = data[3].strategy||[];
            this.part3style = data[3].style||[];
            this.part4Data = data[4];
            this.total = data.total;
            this.get_edit();
            this.getPartIndex();
          }
        });
    },
     get_edit(){
        this.$ajax
        .post(
          this.G_acapi + "/customer/getLearningCapacityInterpretationByStudent",
          {
           
          },
          {
            headers: {
              token: window.sessionStorage.getItem("ymtxToken"),
            },
          }
        )
        .then((res) => {
            console.log(res,'报告解读必填')
            if(res.data.data.length!=0){
              let data = res.data.data;
              this.reliabilityIndex = data.reliabilityIndex
              this.learningAbility = data.learningAbility
              this.learningPotential = data.learningPotential
              this.learningStrategy = data.learningStrategy
              this.learningStyle = data.learningStyle
              this.learningMotivation = data.learningMotivation
              this.mind = data.mind
            }else{

              
            }
        })
    },
    getPartIndex() {
      let isHadReport = false;
      let data1 = this.part1Data;
      let data2 = this.part2Data;
      let data3 = this.part3Data;
      let data4 = this.part4Data;
      let list = this.list;
      let partIndex = 1;
      let listData = list.slice(0, 1);
      if (data1.test_id) {
        isHadReport = true;
        partIndex++;
        this.part1Index = partIndex;
        listData.push(list[1]);
      }

      if (data3.test_id) {
        isHadReport = true;
        partIndex++;
        this.part3Index = partIndex;
        listData.push(list[2]);
      }

      if (data2.test_id) {
        isHadReport = true;
        partIndex++;
        this.part2Index = partIndex;
        listData.push(list[3]);
      }

      if (data4.test_id && (this.isXljkReport == 0 || !this.isXljkReport)) {
        isHadReport = true;
        partIndex++;
        this.part4Index = partIndex;
        listData.push(list[4]);
      }
      this.listData = listData;
      this.isHadReport = isHadReport;
    },
  },
};
</script>
<style type="text/css" lang='less' scoped>
/deep/.buchongs{
    margin-bottom: 38px;  
    textarea {
     min-height: 140px !important;
    }  
}
.evaluationPeport_main {
  margin: 0 auto;
  background: #fff;
  padding: 20px 85px 0px;
}
.title {
  font-size: 32px;
  font-weight: bolder;
  line-height: 80px;
  text-align: center;
  color: #0094ea;
}
.partTitle {
  font-size: 20px;
  color: #2f2f2f;
  font-weight: bolder;
  padding: 30px 0;
  padding-bottom: 0;
}
.line {
  margin-top: 7px;
  height: 2px;
  width: 100%;
  background: -webkit-gradient(
    linear,
    left top,
    right top,
    from(#ffb23a),
    to(#19afbf)
  );
  background: linear-gradient(90deg, #ffb23a, #19afbf);
}
table {
  margin-top: 13px;
  margin-bottom: 38px;
  tr {
    line-height: 45px;
    th {
      width: 130px;
      text-align: center;
      border: 1px solid #dfdede;
      font-size: 14px;
      font-weight: bold;
      background: #f9f8f8;
    }
    td {
      border: 1px solid #dfdede;
      font-size: 12px;
      padding-left: 10px;
    }
  }
}
// 核心结果样式
.page_header {
  color: #fff;
  background-color: #f6a724;
  font-size: 24px;
  text-align: left;
  margin-bottom: 30px;
  line-height: 50px;
  padding-left: 30px;
}
.page_title_2 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  height: 32px;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-bottom: 10px;
  line-height: 32px;
  font-size: 20px;
  font-weight: 700;
}
.arrow {
  display: block;
  margin-left: 10px;
  width: 0;
  height: 0;
  border-top: 9px solid transparent;
  border-left: 14px solid #feae3b;
  border-bottom: 9px solid transparent;
  border-left: 14px solid #feae3b;
}
.page_title_3_0 {
  height: 22px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-bottom: 20px;
  font-size: 16px;
  font-weight: 700;
  padding-top: 10px;
}
.color1 {
  color: #ff0000;
}
.color2 {
  color: #ffc001;
}
.color3 {
  color: #1ca4b6;
}
.color4 {
  color: #92d050;
}
.color5 {
  color: #00b050;
}
.part_detail {
  line-height: 32px;
  margin-bottom: 20px;
}
.part_detail span {
  font-size: 18px;
  font-weight: 700;
}
</style>
